import React, { useCallback, useState } from 'react';

const useCapTable = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleSearchSubmit = useCallback(
    (e?: React.FormEvent, setGlobalFilter?: (v: string) => void) => {
      if (e) e.preventDefault();
      if (setGlobalFilter) setGlobalFilter(searchTerm);
    },
    [searchTerm]
  );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    setGlobalFilter?: (v: string) => void
  ) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (setGlobalFilter) setGlobalFilter(value);
  };

  return {
    handleSearchSubmit,
    searchTerm,
    handleSearchChange,
  };
};

export default useCapTable;
